import React from 'react';
import copy from '../copy';
import { setDocumentTitle } from '@do/seashell';

const useDocumentTitle = (title = ''): void => {
  const brandSuffix = setDocumentTitle(copy.title_suffix);
  React.useEffect(() => {
    window.document.title = `${title ? `${title} | ` : ''}${brandSuffix}`;
  }, [title]);
};

export default useDocumentTitle;
